import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface ProgressBarProps {
    projectName: string;
    completionPercentage: number;
    completedCount: number;
    totalCount: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
    projectName,
    completionPercentage,
    completedCount,
    totalCount
}) => {
    return (
        <Box sx={{
            width: '100%',
            maxWidth: 400,
            mb: 2,
            mx: 'auto',
            px: 2,
            py: 1,
            borderRadius: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 600, fontSize: '0.85rem' }}>
                    {projectName} Progress
                </Typography>
                <Typography variant="body2" sx={{
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    color: completionPercentage > 75 ? '#4caf50' :
                        completionPercentage > 50 ? '#ffc107' :
                            completionPercentage > 25 ? '#ff9800' : '#f44336'
                }}>
                    {completionPercentage}%
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={completionPercentage}
                sx={{
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: completionPercentage > 75 ?
                            'linear-gradient(45deg, #4caf50 30%, #66bb6a 90%)' :
                            completionPercentage > 50 ?
                                'linear-gradient(45deg, #ffc107 30%, #ffb74d 90%)' :
                                completionPercentage > 25 ?
                                    'linear-gradient(45deg, #ff9800 30%, #ffb74d 90%)' :
                                    'linear-gradient(45deg, #f44336 30%, #ef5350 90%)'
                    }
                }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                    {completedCount} of {totalCount} complete
                </Typography>
            </Box>
        </Box>
    );
};

export default ProgressBar;
